<div class="w-full rounded-md px-4 gap-4 flex items-center flex-nowrap py-2 font-semibold text-white text-opacity-80 bg-white bg-opacity-0 hover:bg-opacity-5 cursor-pointer transition-colors"
  [routerLink]="link ? link : undefined"
  routerLinkActive="active">
  <img [attr.src]="icon" class="w-5 h-5 object-contain opacity-80 transition-opacity" routerLinkActive="active">
  <div class="text-xs">{{ title }}</div>
</div>
